let AbstractGeometryOperationResult = require('./abstractOperationResult');

/**
 * Класс BufferResult определяет структуру результата при опрерации построения буфера
 * @extends AbstractGeometryOperationResult
 */
class BufferResult extends AbstractGeometryOperationResult {
  /**
   * Создает экземпляр класса BufferResult
   * @param params
   */
  constructor(params) {
    super(params);
    this.type = "BufferResult";
  }
}

module.exports = BufferResult;